import {ChangeEvent, FC, ReactNode, useRef} from 'react';

interface FileUploaderProps {
  renderTrigger: () => ReactNode;
  onFileSelect: (file: File) => void;
  accept?: string;
}

const FileUploader: FC<FileUploaderProps> = ({renderTrigger, onFileSelect, accept}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleTriggerClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onFileSelect) {
      onFileSelect(file);
    }
  };

  return (
    <>
      <input accept={accept} type='file' ref={fileInputRef} onChange={handleFileChange} style={{display: 'none'}} />
      <div onClick={handleTriggerClick}>{renderTrigger()}</div>
    </>
  );
};

export default FileUploader;
